import './index.css';

import { configAuth } from '@auth/services/configAuth';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { ReloadPageError } from '@components/ReloadPageError';
import { SettingProvider } from '@components/SettingProvider';
import { TailwindIndicator } from '@components/ui/TailwindIndicator';
import { store } from '@store/store';
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import React from 'react';
import { I18nProvider } from 'react-aria';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';

import { Routes } from './utils/routes/react-router-lazy';

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  BarElement,
  Title,
  LineController,
  PointElement,
  Tooltip,
  Legend,
  BarController,
);

configAuth();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary fallback={<ReloadPageError />}>
      <ReduxProvider store={store}>
        <I18nProvider locale="es-CL">
          <SettingProvider>
            <TailwindIndicator />
            <Routes />
          </SettingProvider>
        </I18nProvider>
      </ReduxProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
